module.exports = "/_next/static/images/e0153bd18bbd999cea405dbfffeaac0a-open-graph-logo-large-br.png";